import gsap from "gsap";
import setMvSlider from "./setMvSlider";

const setMvAnim = () => {
  const hero = document.querySelector('.section-hero');
  const heroOverlay = hero.querySelector('.hero-overlay');
  const heroOverlayLogo = hero.querySelector('.hero-overlay__logo');
  const header = document.querySelector('.site-header');

  const tl = gsap.timeline()

  const initAnim = gsap.timeline({
    onComplete: () => {
      if(getComputedStyle(header).opacity == 0) {
        headerAnim.play();
      }
    }
  })

  if (!sessionStorage.getItem("visit")) {
    initAnim
      .set(heroOverlay, {
        clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
      })
      .to(heroOverlayLogo, {
        opacity: 1,
        duration: 1.2,
        ease: 'sine.inOut'
      })
      .to(heroOverlayLogo, {
        opacity: 0,
        duration: .6,
        ease: 'sine.inOut'
      }, '>+=.3')
      .to(heroOverlay, {
        clipPath: 'polygon(0 100%, 100% 100%, 100% 100%, 0 100%)',
        duration: 1,
        ease: 'expo.inOut',
        onStart: () => {
          setTimeout(() => {
            setMvSlider();
          }, 500);
        }
      })
  } else {
    initAnim
      .to(heroOverlay, {
        opacity: 0,
        duration: .5,
        ease: 'sine.inOut'
      })
    setMvSlider();
  }

    const headerAnim = gsap.timeline()
      .set(header, {
        y: -60
      })
      .to(header, {
        opacity: 1,
        duration: 1,
        ease: 'sine.inOut'
      })
      .to(header, {
        y: 0,
        duration: 1,
        ease: 'power3.out'
      }, '<');
    headerAnim.pause();

  tl.add(initAnim)

  window.sessionStorage.setItem("visit", true);
}

export default setMvAnim;